import { fontSizes, ToolTip } from "@hubrise/react-components"
import styled from "styled-components"

export const StyledTags = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.1rem;
`

export const IconDefault = styled.div``

export const IconOverlap = styled.div`
  letter-spacing: -0.6em;

  ::after {
    content: "";
    display: inline-block;
    width: 0.6em;
  }
`

export const IconInterdiction = styled.div`
  position: relative;

  ::after {
    position: absolute;
    content: "🚫";
    top: 0;
    left: 0;
  }
`

export const StyledToolTip = styled(ToolTip)`
  font-size: ${fontSizes._14};
`
